module.exports = __webpack_public_path__ + "static/media/1_10.5342937e.png";